import React, { Component } from 'react'
import './prodinfodownload.scss'
import Button from '../Button'
import Checkbox from '../Checkbox'
import Dropdown from '../Dropdown'
import Separator from '../Separator'
import Tags from '../Tags'

class ProdInfoDownload extends Component {
	constructor(props) {
		super(props)
		this.state = {
			open: false
		}
	}

	toggleDropdown = () => {
		this.setState({ open: !this.state.open })
	}
	selectAll = (listName) => {
		let checks = document.getElementsByName(listName)
		let toggle = document.getElementsByName([listName, 'all'].join('-'))[0]

		//console.log(toggle.checked)
		if (!toggle) {
			checks.forEach(function (check, i) {
				//console.log('check: ',check.checked)
				check.checked = true
			})
		}
		//console.log(checks)
	}

	render() {
		let classes = ['vbui--prodinfodownload', this.props.classes, this.props.state].join(' ')
		let dropdownBtnClasses = ['medium dropdown-btn', this.state.open ? 'fill open-btn' : 'ghost'].join(' ')
		let dropdownElClasses = ['dropdown-element', this.state.open ? 'dropped' : ''].join(' ')
		let characteristics = ''
		var nElements = this.props.data.chars.length
		//console.log(nElements)
		this.props.data.chars.forEach(function (char, i) {
			characteristics = characteristics + char
			if (i < nElements - 1) {
				characteristics = characteristics + ', '
			}
		})
		var checkListName = this.props.data.name
		return (
			<div className={classes}>
				<div className="static-element">
					<div className="img-carrier">
						<div className="crop-element">
							<img src={this.props.data.img} alt="" />
						</div>
					</div>
					<div className="item-info">
						<p className="reference">{this.props.data.ref}</p>
						<p className="name">{this.props.data.name}</p>
						<p className="characteristics">{characteristics}</p>
					</div>
					<div className="btn-carrier">
						<Button classes="ghost medium" showIcon="true" icon="icon-icon-download" onClick={this.props.onClick}>
							{this.props.downloadAllBtn}
						</Button>
						<Button
							classes={dropdownBtnClasses}
							showIcon="true"
							icon={this.state.open ? 'icon-up' : 'icon-down'}
							onClick={this.toggleDropdown}
						>
							{this.props.dropSelBtn}
						</Button>
					</div>
				</div>
				<div className={dropdownElClasses}>
					<Separator classes="thin grey"></Separator>

					<div className="dropdown-content">
						<div className="select-all-check">
							<Checkbox
								name={[checkListName, 'all'].join('-')}
								id={[checkListName, 'all'].join('-')}
								click={() => {
									this.selectAll(checkListName)
								}}
							>
								{this.props.selectAll}
							</Checkbox>
						</div>
						<Separator classes="thin grey"></Separator>
						{this.props.data.elements.map((dataEl, i) => {
							let checkId = [checkListName, i].join('-')
							return (
								<div key={i}>
									<div className="checkbox-wrapper">
										<Checkbox name={checkListName} id={checkId} disabled={dataEl.disabled ? true : false}>
											{dataEl.name}
										</Checkbox>
										{dataEl.disabled && (
											<Tags state="active" classes="no-click extra-item">
												No disponible
											</Tags>
										)}
										{dataEl.dropdown && (
											<Dropdown classes="extra-item" label="Nombre" showIcon="true" options={dataEl.options}></Dropdown>
										)}
									</div>
									<Separator classes="thin grey"></Separator>
								</div>
							)
						})}
						<div className="btn-block">
							<Button classes="fill medium" showIcon="true" icon="icon-icon-download">
								{this.props.downloadSelBtn} ({'2'})
							</Button>
						</div>
					</div>
				</div>
				<Separator classes="medium pink"></Separator>
			</div>
		)
	}
}

export default ProdInfoDownload
